<h3 fxLayout="row">
  <app-fly-to *ngIf="vertexA" [lngLat]="[vertexA.longitude, vertexA.latitude]" i18n>
    Vertex <strong>{{vertexA.id}}</strong>
  </app-fly-to>
  <span fxFlex></span>
  <app-fly-to *ngIf="vertexB" [lngLat]="[vertexB.longitude, vertexB.latitude]" i18n>
    Vertex <strong>{{vertexB.id}}</strong>
  </app-fly-to>
</h3>
<app-loading *ngIf="isLoading else formBlock"></app-loading>

<ng-template #formBlock>

  <form [formGroup]="formEdge" class="app-form">
    <mat-form-field class="app-block" appearance="outline">
      <mat-select i18n-placeholder placeholder="Edge class" formControlName="edge_class">
        <mat-option [disabled]="!item.enabled" *ngFor="let item of edgeClasses " [value]="item.id">
          {{item.name | translation: MODELS_MAPPER}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="app-block" appearance="outline">
      <mat-label i18n>Geometric Distance</mat-label>
      <input matInput [value]="edge.geom_distance" disabled>
      <span matSuffix i18n>meters</span>
    </mat-form-field>
    <mat-form-field class="app-block" appearance="outline">
      <mat-label i18n>User distance</mat-label>
      <input matInput formControlName="user_distance">
      <span matSuffix i18n>meters</span>
    </mat-form-field>
  </form>

  <ng-container *ngIf="edge.edge_class === EdgeClass.U">
    <mat-tab-group backgroundColor="primary">
      <mat-tab i18n-label label="DUCTS DIAGRAM">
        <div class="duct-tab-content">
          <app-edge-duct-diagram *ngIf="properties['ducts'][0].length else ductsEmptyBlock" [properties]="properties">
          </app-edge-duct-diagram>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-error *ngIf="formEdge.get('properties')?.invalid">
            <mat-icon>error</mat-icon>
          </mat-error>
          <span i18n>PROPERTIES</span>
        </ng-template>
        <ng-template matTabContent>
          <div class="duct-tab-content">
            <app-edge-duct-form [edgeForm]="formEdge" [properties]="properties"
              (propertiesChange)="updateProperties($event)"></app-edge-duct-form>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <mat-action-row>
    <button mat-stroked-button color="warn" *ngIf="editionMode" (click)="remove()">
      <span *ngIf="removeConfirmated else removeBlock" i18n>CONFIRM?</span>
    </button>
    <button mat-raised-button (click)="save()" [disabled]="formEdge.invalid" i18n>SAVE</button>
  </mat-action-row>

</ng-template>

<ng-template #removeBlock i18n>REMOVE</ng-template>

<ng-template #ductsEmptyBlock>Ducst not defined, please fill the properties first.</ng-template>
